.container {
  min-height: calc(var(--mirai-ui-space-L) * 4.75);
  max-height: calc(100vh - calc(var(--mirai-ui-space-L) * 4));
  /*padding-left: var(--mirai-ui-space-M);
  padding-right: var(--mirai-ui-space-M);*/
}
